import { render, staticRenderFns } from "./messageItem.vue?vue&type=template&id=d06f900a&scoped=true&"
import script from "./messageItem.vue?vue&type=script&lang=js&"
export * from "./messageItem.vue?vue&type=script&lang=js&"
import style0 from "./messageItem.vue?vue&type=style&index=0&id=d06f900a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d06f900a",
  null
  
)

export default component.exports